"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRocket = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var config_context_1 = require("./config-context");
/**
 * 快速创建 DOM 容器组件
 * @param displayName 组件名称
 * @param paths 组件的容器路径，如 div.tea-card__body
 *
 * tea 类名前缀请使用 `@{prefix}` 代替
 */
exports.createRocket = function (displayName) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    var parentOf = function (classPrefix) { return function (children, path) {
        var _a = tslib_1.__read(path.split(".")), tag = _a[0], classNames = _a.slice(1);
        return react_1.default.createElement(tag, {
            className: classNames
                .map(function (c) { return c.replace(/^(@{prefix}-)/, classPrefix + "-"); })
                .join(" "),
        }, children);
    }; };
    var Rocket = react_1.forwardRef(function (props, ref) {
        var children = props.children, className = props.className, restProps = tslib_1.__rest(props, ["children", "className"]);
        var classPrefix = config_context_1.useConfig().classPrefix;
        var element = paths.reduceRight(parentOf(classPrefix), children);
        if (className) {
            var elementProps = element.props;
            return react_1.default.cloneElement(element, tslib_1.__assign({ ref: ref, className: [elementProps.className, className]
                    .filter(Boolean)
                    .join(" ") }, restProps));
        }
        return react_1.default.cloneElement(element, tslib_1.__assign({ ref: ref }, restProps));
    });
    Rocket.displayName = displayName;
    return Rocket;
};
//# sourceMappingURL=create-rocket.js.map